import React from 'react';
import { jc } from 'utils';
import { Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { Styles } from './review.styles';
import { ReviewAuthorContentProps } from './review-author-content';
import { ReviewRatingScoreProps } from './review-rating-score';

export type ReviewProps = {
  author: React.ReactElement<ReviewAuthorContentProps>;

  ratingScore: React.ReactElement<ReviewRatingScoreProps>;

  additionalInfo: React.ReactNode;

  text: React.ReactNode;
  pros?: React.ReactNode;
  cons?: React.ReactNode;
  likeDislikeGroup?: React.ReactNode;

  photos?: React.ReactElement;
} & React.HTMLAttributes<HTMLElement>;

export const Review: React.FC<ReviewProps> = ({
  author,
  className,
  ratingScore,
  additionalInfo,
  text,
  pros,
  cons,
  likeDislikeGroup,
  photos,
  ...htmlProps
}) => {
  const { t } = useTranslation();
  return (
    <div className={className} {...htmlProps}>
      <div className={Styles.firstRow}>{author}</div>

      <div className={Styles.ratingWrapper}>{ratingScore}</div>

      {additionalInfo}

      {photos && <>{photos}</>}

      <div className={Styles.textRow}>{text}</div>

      {pros ? (
        <div className={jc(Styles.textRow, Styles.textRowProsCons)}>
          <Typography className={Styles.prosConsLabel} variant="s" size="body_accent">
            {t('reviews.review.pros')}
          </Typography>
          <div className={Styles.prosConsContent}>{pros}</div>
        </div>
      ) : null}
      {cons ? (
        <div className={jc(Styles.textRow, Styles.textRowProsCons)}>
          <Typography className={Styles.prosConsLabel} variant="s" size="body_accent">
            {t('reviews.review.cons')}
          </Typography>
          <div className={Styles.prosConsContent}>{cons}</div>
        </div>
      ) : null}

      {likeDislikeGroup ? (
        <div
          data-testid="like-dislike-group__wrapper"
          data-qa="like-dislike-group__wrapper"
          className={Styles.likeDislikeGroupWrapper}
        >
          {likeDislikeGroup}
        </div>
      ) : null}
    </div>
  );
};
